import React, {Component} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export default class Arrow extends Component {
    static propTypes = {
        prev: PropTypes.bool,
        funct: PropTypes.func,
        hide: PropTypes.bool
    };

    clickHandler = () => {
        this.props.funct();
    };

    render() {
        const {prev, hide} = this.props;
        const arrowClass = classNames({hide, prevArrow: prev, nextArrow: !prev});
        const arrowDir = prev ? 'left' : 'right';
        return (
            <div role="presentation" onClick={this.clickHandler} className={arrowClass}>
                <i role="presentation" className={`icon-arrow-${arrowDir}`} />
            </div>
        );
    }
}
